import React, { useEffect, useState } from 'react'
import { useLocation, useHistory } from 'react-router-dom'
import queryString from 'query-string'

import './styles.scss'
import SquareNavbar from 'components/common/SquareNavbar'
import { navbarOptions } from './utils'
import { searchEngineApi } from 'api'
import { lang } from 'utils/helpers'
import MessageBox from './MessageBox'
import PersonBox from './PersonBox'
// import FileBox from './FileBox'
import ChatMailBox from './ChatMailBox'
import { getStaticImage } from 'utils/statics'
import { useSelector } from 'react-redux'
import { Button } from 'components/Form'
import GeneralBox from './GeneralBox'

const SearchResultsView = () => {
  const { searchEngine: { backLocation } } = useSelector(store => store)
  const { pathname, search } = useLocation()
  const { push } = useHistory()
  const { q: text, t: type } = queryString.parse(search)
  const [page, setPage] = useState(0)
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(false)
  const [resultsData, setResultsData] = useState([])
  const [isAllResults, setIsAllResults] = useState(false)

  useEffect(() => {
    setResultsData([])
    deepSearch()
  }, [text, type])

  useEffect(() => {
    deepSearch()
  }, [page])

  const deepSearch = () => {
    if (error) setError('')
    setLoading(true)
    searchEngineApi.deepSearch({ text, type, page })
      .then(({ data }) => {
        const results = data.results
        if (!results.length) setIsAllResults(true)
        setResultsData(prevState => [...prevState, ...results])
      })
      .catch(() => setError(lang('dashboard_error-get-results-search')))
      .finally(() => setLoading(false))
  }

  const handleClose = () => {
    if (!backLocation.pathname || backLocation.pathname?.includes('searchresults')) {
      return push('/dashboard/overview')
    }
    return push(backLocation)
  }

  const handleChangeSection = type => {
    if (page) setPage(0)
    if (isAllResults) setIsAllResults(false)
    if (resultsData.length) setResultsData([])
    push({
      pathname,
      search: `?q=${text}&t=${type}`
    })
  }

  return (
    <div className='search-results-view'>
      <div className='search-results-view__header'>
        <h2 className='search-results-view__title'>
          {lang('dashboard_results-for')} &ldquo;{text}&ldquo;
        </h2>
        <button className='search-results-view__close-btn' onClick={handleClose}>
          <figure>
            <img src={getStaticImage('/icons/orange-brand/icon-close-slim-grey.svg')} alt='Close' />
          </figure>
        </button>
      </div>
      <SquareNavbar
        className='search-results-view__square-navbar'
        items={navbarOptions}
        count={{ type, value: resultsData.length }}
        countLoading={loading}
        value={type}
        onChange={type => handleChangeSection(type)}
      />
      <p className='search-results-view__results-count'>
        {resultsData.length} {lang('dashboard_results')}
      </p>
      <div className='search-results-view__results-container'>
        {resultsData.map((result, index) => {
          if (result.type === 'messages') {
            return (
              <MessageBox
                key={index}
                messageId={result._id}
                user={result.user}
                delegation={result.delegation}
                date={result.date}
                text={result.text}
                channel={result.channel}
              />
            )
          }
          if (result.type === 'people') {
            return (
              <PersonBox
                key={index}
                _conversationId={result._id}
                conversationId={result.id}
                picture={result.picture}
                name={result.name}
                delegation={result.delegation}
                channel={result.channel}
                state={result.state}
              />
            )
          }
          /*
          if (result.type === 'files') {
            return (
              <FileBox
                key={index}
                id={file.id}
                name={file.text}
                size={file.size || '128kb'}
                mimeType={file.mimeType}
                mimeSubtype={file.mimeSubtype}
                url={file.urlLong || file.url}
                thumb={file.thumb}
              />
            )
          }*/
          if (result.type === 'chatmail') {
            return (
              <ChatMailBox
                key={index}
                id={result._id}
                type={result.subtype}
                channel={result.channel}
                state={result.status}
                date={result.date}
                text={result.text}
                user={result.user}
              />
            )
          }
          if (result.type === 'campaigns') {
            return (
              <GeneralBox
                key={index}
                iconSrc={getStaticImage('/icons/orange-brand/icon-campaign-primary-dark.svg')}
                iconAlt={lang('dashboard_campaign')}
                title={result.text}
                description={lang(`status_${result.state}`)}
                date={result.launchDate}
                onClick={() => push(`/dashboard/marketing/campaigns/${result._id}`)}
              />
            )
          }
          if (result.type === 'smartchat') {
            return (
              <GeneralBox
                key={index}
                iconSrc={getStaticImage('/icons/orange-brand/icon-automation-primary-dark.svg')}
                iconAlt={lang('dashboard_smartchat')}
                title={result.text}
                description={result.subtype}
                onClick={() => {
                  const consoleId = result.subtype === 'AV' ? result._id : result.headerId
                  push(`/dashboard/automation/console/${consoleId}${result.subtype === 'FAQ' ? `#${result._id}` : ''}`)
                }}
              />
            )
          }
          return null
        })}
        {error ? (
          <p className='search-results-view__text search-results-view__text--error'>
            {error}
          </p>
        ) : null}
        {!isAllResults ? (
          <Button
            clearPrimary
            value={lang('dashboard_load-more')}
            onClick={() => setPage(prevState => prevState + 1)}
            isSubmitting={loading}
          />
        ) : null}
      </div>
    </div>
  )
}

export default SearchResultsView
